import { apiClient } from './client';
import type {
  ClaimsSearchRequest,
  ClaimsSearchResponse,
  EntitiesSearchRequest,
  EntitiesSearchResponse,
  SemanticSearchRequest,
  SemanticSearchResponse,
} from '@snxt/snxt-onto-share';

/** Set kbId (single) or kbIds (CSV) on the query params. kbIds takes precedence. */
function setKbParams(params: URLSearchParams, req: { kbId?: string; kbIds?: string[] }): void {
  if (req.kbIds && req.kbIds.length > 0) {
    params.set('kbIds', req.kbIds.join(','));
  } else if (req.kbId) {
    params.set('kbId', req.kbId);
  }
}

export const knowledgeSearchApi = {
  /** Search proto-triple claims extracted by L3 (key_claims). */
  searchClaims: (req: ClaimsSearchRequest): Promise<ClaimsSearchResponse> => {
    const params = new URLSearchParams();
    setKbParams(params, req);
    if (req.q) params.set('q', req.q);
    if (req.numericOnly) params.set('numericOnly', 'true');
    if (req.unit) params.set('unit', req.unit);
    if (req.limit != null) params.set('limit', String(req.limit));
    return apiClient.get<ClaimsSearchResponse>(
      `/api/knowledge-search/claims?${params.toString()}`
    );
  },

  /** Search named entities extracted by L3 (entity_candidates). */
  searchEntities: (req: EntitiesSearchRequest): Promise<EntitiesSearchResponse> => {
    const params = new URLSearchParams();
    setKbParams(params, req);
    if (req.q) params.set('q', req.q);
    if (req.entityType) params.set('entityType', req.entityType);
    if (req.limit != null) params.set('limit', String(req.limit));
    return apiClient.get<EntitiesSearchResponse>(
      `/api/knowledge-search/entities?${params.toString()}`
    );
  },

  /** Vector-similarity question search over KU embeddings. */
  searchSemantic: (req: SemanticSearchRequest): Promise<SemanticSearchResponse> =>
    apiClient.post<SemanticSearchResponse>('/api/knowledge-search/semantic', req),
};

// Made with Bob
